import { render, staticRenderFns } from "./Bloques.vue?vue&type=template&id=31ac2c0c"
import script from "./Bloques.vue?vue&type=script&lang=js"
export * from "./Bloques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports